import { render, staticRenderFns } from "./Register-v2.vue?vue&type=template&id=48f2bac8"
import script from "./Register-v2.vue?vue&type=script&lang=js"
export * from "./Register-v2.vue?vue&type=script&lang=js"
import style0 from "./Register-v2.vue?vue&type=style&index=0&id=48f2bac8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports